export default "__VITE_ASSET__87f729d4__"